import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';
import moment from 'moment';
import axios from 'axios';
import XLSX from 'xlsx';

import { DeviceToolbar, DeviceTable, RegisterDevice, UploadDeviceFile } from './components';

import { PageTitle, SimplePopup } from 'components';
import { IsNoU } from 'common/utils';

import { toast } from 'react-toastify';

import serverURI from 'config/URI';

// >> redux
import {
  getDevices,
  addDevice,
  updateDevice,
  deleteDevice,
  findDevices,
  removeDevices,

  findDeviceLogs,
  removeDeviceLogs,
  deleteDeviceLogs,

  findDeviceErrors,
  removeDeviceErrors,
  deleteDeviceErrors,

  findDeviceHistories,
  removeDeviceHistories,
  deleteDeviceHistories,

  getModems,
  addModem,
  updateModem,
  deleteModem,
  findModems,
  removeModems,

  findModemHistories,
  removeModemHistories,
  deleteModemHistories,
} from '../../redux/actions/devices';
// <<


// >> redux
import {
  getCompanyNames,
  getCarNumbers,
  // addCar,
  // updateCar,
  // deleteCar,
} from '../../redux/actions/companies';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Device = (props) => {
  const classes = useStyles();

  const { type } = props.match.params;

  //const [devices] = useState(mockData);
  const { 
    reged_devices,
    devices, 
    logs, 
    errors,
    histories,
    modems, 
    mhistories,
    loading, 
    loading_find_device,
    device_total,
    companies, 
    cars, 
    areas, 
    groups 
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());

  const [selectedDeleteStartDate, setSelectedDeleteStartDate] = useState(new Date());
  const [selectedDeleteEndDate, setSelectedDeleteEndDate] = useState(new Date());


  const [modeRegisterDevice, setModeRegisterDevice] = useState(true);
  const [openRegisterDevice, setOpenRegisterDevice] = useState(false);
  const [disableEditDeviceButton, setDisableEditDeviceButton] = useState(true);
  const [disableDeleteDeviceButton, setDisableDeleteDeviceButton] = useState(true);

  const [editDevice, setEditDevice] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  const [find_data, set_find_data] = useState({});
  const handleFindDevice = (serialNo, carnumber, company, statusDevice, installedDevice) => {

    //console.log(serialNo + ',' + carnumber + ',' + company + ',' + statusDevice + ',' + installedDevice);

    let find = {};

    if (!IsNoU(serialNo) && serialNo.length > 0) {
      find.serial_no = serialNo;
    }

    if (!IsNoU(carnumber) && carnumber.length > 0) {
      find.car_number = carnumber;
    }

    if (!IsNoU(company) && company.length > 0) {
      find.company = company;
    }

    if (!IsNoU(statusDevice) && statusDevice.length > 0 && statusDevice !== '전체') {
      find.status = statusDevice;
    }

    if (!IsNoU(installedDevice) && installedDevice.length > 0 && installedDevice !== '전체') {
      find.installed = installedDevice;
    }

    find.page = 0;
    find.rows_per_page = rowsPerPage

    set_find_data(find);

    // const find = {
    //   serial_no: serialNo, 
    //   car_number: carnumber, 
    //   company, 
    //   status: statusDevice, 
    //   installed: installedDevice
    // }
    props.findDevices(find);
  }

  const handleFindDeviceLog = (startDate, endDate, carnumber, company, logResult) => {

    //console.log(startDate + ',' + endDate + ',' + carnumber + ',' + company + ',' + statusDevice + ',' + installedDevice);

    const find = {};

    // let compare_date = new Date('2020-01-01');
    // if (compare_date.getTime() !== startDate.getTime() 
    //   && compare_date.getTime() !== endDate.getTime()) {
        find.start_date = startDate;
        find.end_date = endDate;
    // }

    if (!IsNoU(carnumber)) find.car_number = carnumber;
    if (!IsNoU(company)) find.company = company;
    if (!IsNoU(logResult)) find.log_result = logResult;

    find.page = 0;
    find.rows_per_page = rowsPerPage;

    set_find_data(find);

    props.findDeviceLogs(find);
  }

  const handleDeleteAllDeviceLog = (startDate, endDate) => {

    //console.log(startDate + ',' + endDate);

    setDeleteAlertMsg('일괄삭제 하시겠습니까 ?');
    setOpenDeleteAlert(true);

  }

  const handleFindDeviceErrors = (carNumber, company) => {

    let find = {};
    if (!IsNoU(carNumber) && carNumber.length > 0) find.car_number = carNumber;
    if (!IsNoU(company) && company.length > 0) find.company = company;
    
    find.page = 0;
    find.rows_per_page = rowsPerPage;

    set_find_data(find);

    props.findDeviceErrors(find);

  }
  const handleDeleteAllDeviceErrors = () => {
    setDeleteAlertMsg('일괄삭제 하시겠습니까 ?');
    setOpenDeleteAlert(true);
  }

  const handleFindDeviceHistory = (serialNo) => {

    let find = {};
    if (!IsNoU(serialNo) && serialNo.length > 0) find.serial_no = serialNo;
    //if (!IsNoU(company) && company.length > 0) find.company = company;

    //console.log(find)

    // let compare_date = new Date('2020-01-01');
    // if (compare_date.getTime() !== selectedStartDate.getTime() 
    //   && compare_date.getTime() !== selectedEndDate.getTime()) {
    //   console.log(selectedStartDate);
    //   console.log(selectedEndDate);
      find.start_date = selectedStartDate;
      find.end_date = selectedEndDate;
    // }

    find.page = 0;
    find.rows_per_page = rowsPerPage;

    set_find_data(find);

    props.findDeviceHistories(find);
  }
  const handleDeleteAllDeviceHistory = () => {
    setDeleteAlertMsg('일괄삭제 하시겠습니까 ?');
    setOpenDeleteAlert(true);
  }

  const handleFindModem = (serialNo, deviceSerialNo, telecom, statusDevice, installedDevice) => {
    let find = {};

    if (!IsNoU(serialNo) && serialNo.length > 0) find.serial_no = serialNo;
    if (!IsNoU(deviceSerialNo) && deviceSerialNo.length > 0) find.device_serial_no = deviceSerialNo;
    if (!IsNoU(telecom) && telecom.length > 0) find.telecom = telecom;
    if (!IsNoU(statusDevice) && statusDevice !== '전체') find.status = statusDevice;
    if (!IsNoU(installedDevice) && installedDevice !== '전체') find.installed = installedDevice;

    setPage(0);

    find.page = 0;
    find.rows_per_page = rowsPerPage;

    props.findModems(find);
  }

  const handleFindModemHistory = (serialNo) => {
    let find = {};

    if (!IsNoU(serialNo) && serialNo.length > 0) find.serial_no = serialNo;

    // let compare_date = new Date('2020-01-01');
    // if (compare_date.getTime() !== selectedStartDate.getTime() 
    //   && compare_date.getTime() !== selectedEndDate.getTime()) {
      find.start_date = selectedStartDate;
      find.end_date = selectedEndDate;
    // }

    find.page = 0;
    find.rows_per_page = rowsPerPage;

    set_find_data(find);

    props.findModemHistories(find);
  }

  const handleDeleteAllModemHistory = () => {
    setDeleteAlertMsg('일괄삭제 하시겠습니까 ?');
    setOpenDeleteAlert(true);
  }


  const handleClickOpenRegisterDevice = () => {
    setEditDevice(null);
    setModeRegisterDevice(true);

    setOpenRegisterDevice(true);
  }

  const handleClickOpenEditDevice = () => {

    if (selectedItems.length !== 1){
      return ;
    }
    const id = selectedItems[0];
    let selectedDevice;
    if (type === 'manage')
      selectedDevice = devices.find(device => (device.id === id));
    else if (type === 'modem')
      selectedDevice = modems.find(modem => (modem.id === id));

    //console.log(selectedDevice);
    setEditDevice(selectedDevice);
    setModeRegisterDevice(false);

    setOpenRegisterDevice(true);
  }

  const handleClickCloseRegisterDevice = () => {
    setOpenRegisterDevice(false);
  }

  const handleClickSaveDevice = (device) => {
    if (modeRegisterDevice) {
      if (type === 'manage')
        props.addDevice(device);
      else if (type === 'modem')
        props.addModem(device);
    }
    else if (!modeRegisterDevice && selectedItems.length === 1)
    {
      if (type === 'manage')
        props.updateDevice(device.id, device);
      else if (type === 'modem')
        props.updateModem(device.id, device);
    }
    else
    {
      
    }
    setOpenRegisterDevice(false);
  }


  const [deleteAlertMsg, setDeleteAlertMsg] = useState('');
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  const handleClickOpenDelete = () => {
    if (type === 'manage' || type === 'modem') {
      if (selectedItems.length === 0){
        return ;
      }
      setDeleteAlertMsg(`선택한 데이터를 삭제하시겠습니까?`);
    }
    // else if (type === 'logs') {
    // }
    setOpenDeleteAlert(true);
  };

  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  }
  const handleClickDeleteAlertOk = () => {

    if (type === 'manage' || type === 'modem') {
      //console.log('handleClickDeleteAlertOk -> ' + selectedTemplates.length);
      // if (selectedItems.length == 0){
      //   return ;
      // }

      let deletes;
      if (type === 'manage') {
        deletes = selectedItems.map((selected)=>{
          return devices.find(device => (device.id === selected));
        });
        props.deleteDevice(deletes);
      }
      else if (type === 'modem') {
        deletes = selectedItems.map((selected)=>{
          return modems.find(modem => (modem.id === selected));
        });
        props.deleteModem(deletes);
      }
    }
    else if (type === 'logs' || type === 'errors' || type === 'history' || type === 'mhistory') {
      const deleteDate = {
        start_date : selectedDeleteStartDate, 
        end_date : selectedDeleteEndDate
      }
      //console.log(deleteDate);
      if (type === 'logs')
        props.deleteDeviceLogs(deleteDate);
      else if (type === 'errors')
        props.deleteDeviceErrors(deleteDate);
      else if (type === 'history')
        props.deleteDeviceHistories(deleteDate);
      else if (type === 'mhistory')
        props.deleteModemHistories(deleteDate);
    }

    setOpenDeleteAlert(false);
  }

  const [openUploadDialog, setOpenUploadDialog] = useState(false);

  const handleClickOpenUpload = () => {
    setOpenUploadDialog(true);
  };

  const handleDownloadDeviceFile = async () => {
    let download_url = '';
    if (type === 'manage')
      download_url = `${serverURI}/api/device/download`;
    else if (type === 'logs')
      download_url = `${serverURI}/api/device/log/download`;
    else if (type === 'errors')
      download_url = `${serverURI}/api/device/error/download`;
    else if (type === 'history')
      download_url = `${serverURI}/api/device/history/download`;
    else if (type === 'modem')
      download_url = `${serverURI}/api/modem/download`;
    else if (type === 'mhistory')
      download_url = `${serverURI}/api/modem/history/download`;

    const res = await axios.post(download_url, find_data);
    console.log(res);
    let excel_datas = [];
    var wscols = [];
    let sheet_name = '';

    const dateNow = new Date();
    let fileName = 'report_excel';

    if (type === 'manage') {
      const results = res.data.devices;
      excel_datas = results.map(device => {
        return {
          '모델명' : device.name,
          '시리얼 NO' : device.serial_no,
          'MAC Address' : device.mac,
          '디바이스현황' : device.status,
          '디바이스상태' : device.installed,
          '택시회사명' : device.company,
          '차량번호' : device.car_number,
        };
      });

      sheet_name = '디바이스정보';

      wscols = [
        {wch:20},
        {wch:20},
        {wch:20},
        {wch:16},
        {wch:16},
        {wch:16},
        {wch:16},
      ];

      fileName = `report_device_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }
    else if (type === 'logs') {
      const results = res.data.logs;
      excel_datas = results.map(log => {
        return {
          '택시회사명' : log.company,
          '차량번호' : log.car_number,
          '시리얼 NO' : log.serial_no,
          '상태' : !IsNoU(log.gps_latitude) && !IsNoU(log.gps_longitude) ? 'GPS' : 
                   !IsNoU(log.power) ? log.power ? '부팅' : '종료' :
                    '',
          '일시' : moment(log.log_at).format('YYYY-MM-DD HH:mm:ss'),
          '결과' : log.result ? '성공' : '실패',
        };
      });

      sheet_name = '디바이스로그';

      wscols = [
        {wch:20},
        {wch:20},
        {wch:16},
        {wch:10},
        {wch:20},
        {wch:10},
      ];

      fileName = `report_device_log_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }
    else if (type === 'errors') {
      const errors = res.data.errors;
      excel_datas = errors.map(error => {
        return {
          '시리얼 NO' : error.serial_no,
          '택시회사명' : error.company,
          '차량번호' : error.car_number,
          '미접속일' : error.error_days + '일',
          '발생일' : moment(error.reg_at).format('YYYY-MM-DD'),
        };
      });

      sheet_name = '디바이스장애현황';

      wscols = [
        {wch:20},
        {wch:20},
        {wch:16},
        {wch:10},
        {wch:16},
      ];

      fileName = `report_device_error_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }
    else if (type === 'history') {
      const histories = res.data.histories;
      excel_datas = histories.map(history => {
        return {
          '시리얼 NO' : history.serial_no,
          '디바이스현황' : history.status,
          '디바이스상태' : history.installed,
          '택시회사명' : history.company,
          '차량번호' : history.car_number,
          '수정일' : moment(history.modified_at).format('YYYY-MM-DD'),
        };
      });

      sheet_name = '디바이스상태이력';

      wscols = [
        {wch:20},
        {wch:16},
        {wch:16},
        {wch:20},
        {wch:20},
        {wch:16},
      ];

      fileName = `report_device_history_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }
    else if (type === 'modem') {
      const modems = res.data.modems;
      excel_datas = modems.map(modem => {
        return {
          '모델명' : modem.name,
          '시리얼 NO' : modem.serial_no,
          '통신회사' : modem.telecom,
          '디바이스 시리얼' : modem.device_serial_no,
          '등록자' : modem.reg_user,
          '등록일' : moment(modem.reg_at).format('YYYY-MM-DD'),
        };
      });

      sheet_name = '모뎀정보';

      wscols = [
        {wch:20},
        {wch:20},
        {wch:16},
        {wch:20},
        {wch:16},
        {wch:16},
      ];

      fileName = `report_modem_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }
    else if (type === 'mhistory') {
      const mhistories = res.data.mhistories;
      excel_datas = mhistories.map(mhistory => {
        return {
          '모델명' : mhistory.name,
          '시리얼 NO' : mhistory.serial_no,
          '모뎀현황' : mhistory.status,
          '모뎀상태' : mhistory.installed,
          '디바이스 시리얼' : mhistory.device_serial_no,
          '수정일' : moment(mhistory.reg_at).format('YYYY-MM-DD'),
        };
      });

      sheet_name = '모뎀상태이력';

      wscols = [
        {wch:20},
        {wch:20},
        {wch:16},
        {wch:16},
        {wch:20},
        {wch:16},
      ];

      fileName = `report_modem_history_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }

    const new_workbook = XLSX.utils.book_new(); // excel 파일에 해당 
    const worksheet = XLSX.utils.json_to_sheet(excel_datas); // excel sheet하단의 worksheet에 해당 
    worksheet['!cols'] = wscols;

    XLSX.utils.book_append_sheet(new_workbook, worksheet, sheet_name); // excelsheet를 excel파일에 넣음 
    XLSX.writeFile(new_workbook, fileName + '.xlsx');
  }

  const handleClickOpenDownload = () => {
    if ((type === 'manage' && devices.length === 0)
      || (type === 'logs' && logs.length === 0)
      || (type === 'errors' && errors.length === 0)
      || (type === 'history' && histories.length === 0)
      || (type === 'modem' && modems.length === 0)
      || (type === 'mhistory' && mhistories.length === 0))
      {
        toast('검색 정보가 없습니다.');
        return ;
      }
    handleDownloadDeviceFile();
  };

  const handleClickCloseUploadDialog = () => {
    setOpenUploadDialog(false);
  }

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handlePageChange = (event, page) => {
    setPage(page);
    if (type === 'manage') {
      let find_page_data = {
        serial_no: find_data.serial_no,
        car_number: find_data.carnumber,
        company: find_data.company,
        status: find_data.status,
        installed: find_data.installed,
        page: page,
        rows_per_page: rowsPerPage,
      };
      set_find_data(find_page_data);

      props.findDevices(find_page_data);
    }
    else if (type === 'logs') {
      let find_page_data = {
        start_date: find_data.start_date,
        end_date: find_data.end_date,
        car_number: find_data.car_number,
        company: find_data.company,
        log_result: find_data.log_result,
        page: page,
        rows_per_page: rowsPerPage,
      };
      set_find_data(find_page_data);

      props.findDeviceLogs(find_page_data);
    }
    else if (type === 'errors') {
      let find_page_data = {
        car_number: find_data.car_number,
        company: find_data.company,
        page: page,
        rows_per_page: rowsPerPage,
      };
  
      set_find_data(find_page_data);
  
      props.findDeviceErrors(find_page_data);
    }
    else if (type === 'history') {
      let find_page_data = {
        serial_no: find_data.serial_no,
        start_date: find_data.start_date,
        end_date: find_data.end_date,
        page: page,
        rows_per_page: rowsPerPage,
      };
  
      set_find_data(find_page_data);
  
      props.findDeviceHistories(find_page_data);
    }
    else if (type === 'modem') {
     let find_page_data = {
        serial_no: find_data.serial_no,
        device_serial_no : find_data.device_serial_no,
        telecom : find_data.telecom,
        status : find_data.status,
        installed : find_data.installed,
        page: page,
        rows_per_page: rowsPerPage,
      };

      props.findModems(find_page_data);
    }
    else if (type === 'mhistory') {
      let find_page_data = {
        serial_no: find_data.serial_no,
        start_date : find_data.start_date,
        end_date : find_data.end_date,
        page: page,
        rows_per_page: rowsPerPage,
      };

      props.findModemHistories(find_page_data);
    }
  };

  const handleRowsPerPageChange = e => {
    let rows_per_page = e.target.value;
    setRowsPerPage(rows_per_page);
    setPage(0);
    if (type === 'manage') {
      let find_page_data = {
        serial_no: find_data.serial_no,
        car_number: find_data.carnumber,
        company: find_data.company,
        status: find_data.status,
        installed: find_data.installed,
        page: page,
        rows_per_page: rows_per_page,
      };
      set_find_data(find_page_data);

      props.findDevices(find_page_data);
    }
    else if (type === 'logs') {
      let find_page_data = {
        start_date: find_data.start_date,
        end_date: find_data.end_date,
        car_number: find_data.car_number,
        company: find_data.company,
        log_result: find_data.log_result,
        page: 0,
        rows_per_page: rows_per_page,
      };
      set_find_data(find_page_data);

      props.findDeviceLogs(find_page_data);
    }
    else if (type === 'errors') {
      let find_page_data = {
        car_number: find_data.car_number,
        company: find_data.company,
        page: 0,
        rows_per_page: rows_per_page,
      };
  
      set_find_data(find_page_data);
  
      props.findDeviceErrors(find_page_data);
    }
    else if (type === 'history') {
      let find_page_data = {
        serial_no: find_data.serial_no,
        start_date: find_data.start_date,
        end_date: find_data.end_date,
        page: 0,
        rows_per_page: rows_per_page,
      };
  
      set_find_data(find_page_data);
  
      props.findDeviceHistories(find_page_data);
    }
    else if (type === 'modem') {
      let find_page_data = {
         serial_no: find_data.serial_no,
         device_serial_no : find_data.device_serial_no,
         telecom : find_data.telecom,
         status : find_data.status,
         installed : find_data.installed,
         page: 0,
         rows_per_page: rows_per_page,
       };
 
       props.findModems(find_page_data);
     }
     else if (type === 'mhistory') {
      let find_page_data = {
        serial_no: find_data.serial_no,
        start_date : find_data.start_date,
        end_date : find_data.end_date,
        page: 0,
        rows_per_page: rows_per_page,
      };

      props.findModemHistories(find_page_data);
    }
  };

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
    props.getCompanyNames();
    props.getCarNumbers();
    props.getDevices();
    //props.getModems();
    // else if (type === 'cars')
    //   props.getCars();

    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }
    return () => {
      //console.log("componentDidUnmount");
      props.removeDevices();
      props.removeDeviceLogs();
      props.removeDeviceErrors();
      props.removeDeviceHistories();
      props.removeModems();
      props.removeModemHistories();
    };
  }, []);


  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');

    if (type !== 'manage') props.removeDevices();
    if (type !== 'logs') props.removeDeviceLogs();
    if (type !== 'errors') props.removeDeviceErrors();
    if (type !== 'history') props.removeDeviceHistories();
    if (type !== 'modem') props.removeModems();
    if (type !== 'mhistory') props.removeModemHistories();

    if (type === 'modem')
      props.getDevices();

    setSelectedStartDate(new Date());
    setSelectedEndDate(new Date());
 
  }, [type]);

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditDeviceButton(selectedItems.length != 1);
    setDisableDeleteDeviceButton(selectedItems.length < 1);

  }, [selectedItems]);

  if (loading) {
    return <WaveLoading />;
  }

  return (
    <div className={classes.root}>

      {type !== 'manage' && type !== 'logs' && type !== 'errors' && type !== 'history' && type !== 'modem' && type !== 'mhistory'&& <Redirect to="/not-found"/>}

      <PageTitle
        //pageTitle={'디바이스관리'}
        pageTitle={type === 'manage'? '디바이스관리' : 
          type === 'logs'? '디바이스 로그' : 
          type === 'errors'? '디바이스 장애현황' : 
          type === 'history'? '디바이스 상태이력' : 
          type === 'modem'? '모뎀관리' : 
          '모뎀상태이력'}
      />

      <DeviceToolbar 
        userRole={userRole}
        type={type}
        onClickFindDevice={handleFindDevice}
        onClickFindDeviceLog={handleFindDeviceLog}
        onClickDeleteAllDeviceLog={handleDeleteAllDeviceLog}

        onClickFindDeviceErrors={handleFindDeviceErrors}
        onClickDeleteAllDeviceErrors={handleDeleteAllDeviceErrors}

        onClickFindDeviceHistory={handleFindDeviceHistory}
        onClickDeleteAllDeviceHistory={handleDeleteAllDeviceHistory}

        onClickFindModem={handleFindModem}
        onClickFindModemHistory={handleFindModemHistory}
        onClickDeleteAllModemHistory={handleDeleteAllModemHistory}

        selectedStartDate={selectedStartDate}
        setSelectedStartDate={setSelectedStartDate}
        selectedEndDate={selectedEndDate}
        setSelectedEndDate={setSelectedEndDate}

        selectedDeleteStartDate={selectedDeleteStartDate}
        setSelectedDeleteStartDate={setSelectedDeleteStartDate}
        selectedDeleteEndDate={selectedDeleteEndDate}
        setSelectedDeleteEndDate={setSelectedDeleteEndDate}
        
        cars={cars}
        companies={companies}
        />

      <div className={classes.content}>
        <DeviceTable 
          userRole={userRole}
          type={type}
          devices={devices}
          logs={logs}
          errors={errors}
          histories={histories}
          modems={modems}
          mhistories={mhistories}
          onSetSelectedDevices={(checks) => {setSelectedItems(checks)}}
          onClickOpenRegister={handleClickOpenRegisterDevice}
          onClickOpenEdit={handleClickOpenEditDevice}
          onClickOpenDelete={handleClickOpenDelete}
          disableEditButton={disableEditDeviceButton}
          disableDeleteButton={disableDeleteDeviceButton}

          onClickOpenUploadDialog={handleClickOpenUpload}
          onClickOpenDownloadDialog={handleClickOpenDownload}

          openProgress={loading_find_device}
          page={page}
          rowsPerPage={rowsPerPage}
          item_total={device_total}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          />
      </div>

      <RegisterDevice
        openDialog = {openRegisterDevice}
        modeRegisterDialog = {modeRegisterDevice}
        onClickCloseDialog = {handleClickCloseRegisterDevice}
        onClickSaveDialog = {handleClickSaveDevice}
        userName = {userName}

        type={type}
        companies={companies}
        cars={cars}
        devices={reged_devices}
        areas={areas}
        groups={groups}
        editDevice = {editDevice}
        />

      <UploadDeviceFile
        type={type}
        openDialog={openUploadDialog}
        onClickCloseDialog={handleClickCloseUploadDialog}
        // onClickUploadFile={handleClickUploadFile}
        // onClickDownloadFile={handleClickFromDownload}
        user_name={userName}
        />
          

        <SimplePopup
          title={deleteAlertMsg} 
          openPopup={openDeleteAlert} 
          onClickClose={handleClickCloseDeleteAlert} 
          onClickOk={handleClickDeleteAlertOk}
          />
    </div>
  );
};

//export default Device;

Device.propTypes = {
  loading: PropTypes.bool,
  devices: PropTypes.arrayOf(PropTypes.object),
  logs: PropTypes.arrayOf(PropTypes.object),
  errors: PropTypes.arrayOf(PropTypes.object),
  histories: PropTypes.arrayOf(PropTypes.object),
  modems: PropTypes.arrayOf(PropTypes.object),
  mhistories: PropTypes.arrayOf(PropTypes.object),

  companies: PropTypes.arrayOf(PropTypes.object),
  cars: PropTypes.arrayOf(PropTypes.object),
  areas: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
};


Device.defaultProps = {
  loading: false,
  devices: [],
  logs: [],
  errors: [],
  histories: [],
  modems: [],
  mhistories: [],

  companies: [],
  cars: [],
  areas: [],
  groups: [],
};

const mapStateToProps = state => ({
  loading: state.devices.loading,
  loading_find_device: state.devices.find_device_loading,
  reged_devices: state.devices.reged_deviceList,
  devices: state.devices.deviceList,
  logs: state.devices.deviceLogList,
  errors: state.devices.deviceErrorList,
  histories: state.devices.deviceHistoryList,
  modems: state.devices.modemList,
  mhistories: state.devices.modemHistoryList,
  device_total: state.devices.device_total,

  companies: state.companies.companyNameList,
  cars: state.companies.carNumberList,
  areas: state.manage.reged_areaList,
  groups: state.manage.groupList,
});

const mapDispatchToProps = dispatch => ({
  getDevices: () => {getDevices(dispatch)},
  addDevice: (device) => {addDevice(device, dispatch)},
  updateDevice: (id, device) => {updateDevice(id, device, dispatch)},
  deleteDevice: (deletes) => {deleteDevice(deletes, dispatch)},

  findDevices: (find) => {findDevices(find, dispatch)},
  removeDevices: () => {removeDevices(dispatch)},

  findDeviceLogs: (find) => {findDeviceLogs(find, dispatch)},
  removeDeviceLogs: () => {removeDeviceLogs(dispatch)},
  deleteDeviceLogs: (deleteDate) => {deleteDeviceLogs(deleteDate, dispatch)},

  findDeviceErrors: (find) => {findDeviceErrors(find, dispatch)},
  removeDeviceErrors: () => {removeDeviceErrors(dispatch)},
  deleteDeviceErrors: (deleteDate) => {deleteDeviceErrors(deleteDate, dispatch)},

  findDeviceHistories: (find) => {findDeviceHistories(find, dispatch)},
  removeDeviceHistories: () => {removeDeviceHistories(dispatch)},
  deleteDeviceHistories: (deleteDate) => {deleteDeviceHistories(deleteDate, dispatch)},

  getModems: () => {getModems(dispatch)},
  addModem: (device) => {addModem(device, dispatch)},
  updateModem: (id, device) => {updateModem(id, device, dispatch)},
  deleteModem: (deletes) => {deleteModem(deletes, dispatch)},

  findModems: (find) => {findModems(find, dispatch)},
  removeModems: () => {removeModems(dispatch)},

  findModemHistories: (find) => {findModemHistories(find, dispatch)},
  removeModemHistories: () => {removeModemHistories(dispatch)},
  deleteModemHistories: (deleteDate) => {deleteModemHistories(deleteDate, dispatch)},

  getCompanyNames: () => {getCompanyNames(dispatch)},
  getCarNumbers: () => {getCarNumbers(dispatch)},
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Device);